/*
 * Created by alex@hackerbay.com on 4.2.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import moment from "moment";

export default function timeSlotFormatter(ds360Timeslot){
    const startHour = moment.utc(ds360Timeslot.start).get("hour");
    const endHour = moment.utc(ds360Timeslot.end).get("hour");
    return {
        startHour: startHour,
        endHour: endHour,
        text: `${startHour}-${endHour}`
    }
}